
import { defineComponent, ref, onMounted, PropType, computed } from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import eventModel from "@/core/models/share/inviteEvent.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";
import {
  Module as HosterModule,
  Actions as HosterActions,
  Getters as HosterGetters,
} from "@/store/enums/hosterEnums";

import { useStore } from "vuex";
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
} from "@/store/enums/paramsEnums";

export default defineComponent({
  name: "hosterResponseModalFinish",
  components: {},
  props: {
    event: { type: Object as PropType<eventModel | null> },
  },
  setup(props: any, context: any) {
    const store = useStore();
    const attendee = computed<Array<invitePersonModel>>(
      () => store.getters[HosterModule.desc + HosterGetters.InvitePerson]
    );
    function datetimeFormat(dateFrom: string) {
      return dayjs( dateFrom).format("YYYY/MM/DD (ddd) HH:mm ~ ");
    }

    onMounted(() => {});

    return { datetimeFormat,  attendee, ParamIsResolution, ParamHasReply, dayjs };
  },
});
